module.exports = __webpack_public_path__ + "img/8.67275db7.png";